import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Up = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="up icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.5858 13.2426C18.3668 14.0237 19.6332 14.0237 20.4142 13.2426C21.1953 12.4616 21.1953 11.1953 20.4142 10.4142L12 2L3.58579 10.4142C2.80474 11.1953 2.80474 12.4616 3.58579 13.2426C4.36683 14.0237 5.63317 14.0237 6.41421 13.2426L10 9.65685L10 20C10 21.1046 10.8954 22 12 22C13.1046 22 14 21.1046 14 20L14 9.65685L17.5858 13.2426Z"
    />
  </svg>
)
